/**
 * Portal Component
 * Renders children into a different DOM subtree
 */

import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Portal Component
 * Renders children into a specified container or document.body
 * 
 * @example
 * <Portal>
 *   <div>This renders at document.body</div>
 * </Portal>
 */
export const Portal = ({ 
  children, 
  containerRef,
}) => {
  const mountNode = containerRef?.current || 
    (typeof document !== 'undefined' ? document.body : null);

  if (!mountNode) return null;

  return createPortal(children, mountNode);
};

Portal.displayName = 'Portal';

export default Portal;
